<template>
    <div class="page-container">
        <div class="price-section">
            <div class="price-section-top" >
                <div class="price-text">{{action == 'tihuo' ? '需支付运费' : '本次订单金额'}}</div>
                <div class="price-count">
                    ￥ {{action == 'tihuo' ? freight : amount}}
                </div>
            </div>
            <div class="price-section-bottom">
                <div>付款账户</div>
                <div>{{action == 'duihuan' ? '推荐奖励账户' : '御粮账户'}}</div>
            </div>
        </div>
        <div class="page-content step-2">
            <div class="page-top">
                <div>为了保证您的账户安全</div>
                <div>将向您的 <span>{{displayMobile}}</span> 手机号码发送验证码</div>
            </div>
            <div class="input-grp">
                <div class="pic-code-box">
                    <input type="text" v-model="picCode" placeholder="请输入图片计算结果">
                    <img :src="imgSrc" @click="getPicCode" alt="" class="code-pic">
                </div>
                <!-- <div class="notice" v-show="piccodeError">图形验证码不正确</div> -->
            </div>
            <div class="msg-code-box">
                <input type="text" maxlength="6" v-model="msgCode" placeholder="请输入短信验证码">
                <span class="btn-getcode">
                    <span @click="sendMsg" v-show="!showCountdown">获取验证码</span>
                    <span v-show="showCountdown">(<van-count-down ref="countDown" :time="time" :auto-start="false" format="ss" @finish="countdownFinish" />s)重新获取</span>
                </span>
            </div>
            <div class="btn-confirm" @click="confirm">确认</div>
            <!-- <div class="btn-confirm disabled">确认</div> -->
        </div>
        <div class="page-bottom">
            <a href="tel:4001017057">客服电话：4001017057</a>
        </div>
    </div>
</template>
<script>
import { Field,CountDown,Toast } from 'vant'

import {phoneYm} from '@/lib/util'
import $http from '@/lib/request'
import config from '@/config'
import md5 from 'js-md5'

export default {
    data(){
        return {
            passwd1:'',
            passwd2:'',
            passwd1Error:false,
            passwd2Error:false,
            piccodeError:true,
            passwdOrigin:'',
            picCode:'',//图片验证码
            msgCode:'',//短信验证码
            time: 60 * 1000,//短信验证码倒计时
            showCountdown:false,//是否展示倒计时
            mobile:'',//用户手机号
            displayMobile:'',//用来展示的中间加***的手机号
            imgSrc:'',//图片验证码
            originImgsrc:'',//接口返回的原始图片验证码流
            freight:0,//运费
            action:'',//从哪来的
            amount:0,//本次订单所需金额
        }
    },
    components:{
        [Field.name]:Field,
        [CountDown.name]:CountDown,
        [Toast.name]:Toast
    },
    activated(){
        let mobile=JSON.parse(window.localStorage.getItem('userInfo')).mobile;
        this.displayMobile=phoneYm(mobile)
        this.mobile=mobile;

        try{
            this.freight=this.$route.params.freight;
            this.amount=this.$route.params.amount;
            this.action=this.$route.params.action;
        }catch{
            console.log('路由取参错误');
        }

        this.getPicCode();
    },
    deactivated(){
        this.picCode='';
        this.msgCode='';
        this.time= 60 * 1000;//短信验证码倒计时
        this.$refs.countDown.reset();
    },
    methods:{
        //获取图片验证码
        getPicCode(){
            $http({
                method:'post',
                url:config.api.graphCode
            }).then((res)=>{
                if(res.errno == 0){
                    this.imgSrc='data:image/png;base64,'+res.data.imgsrc;
                    this.originImgsrc=res.data.imgsrc;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        confirm(){
            let url;
            let action = this.$route.params.action;
            let toastTxt;
            if(action && action == 'tihuo'){ //从提货来的
                url = config.api.realConfirmPickup;
                toastTxt = '提货申请成功';
            }else if(action && action == 'jinhuo'){//从进货来的
                url = config.api.confirmPickapply;
                toastTxt = '进货申请成功';
            }else{//从兑换来的
                url = config.api.prevUseReferral;
                toastTxt = '兑换成功';
            }
            $http({
                method:'post',
                data:{
                    orderId:this.$route.params.orderId,
                    jyPassword:'',
                    vCodeKey:'vcode'+md5(this.originImgsrc),
                    verifyCode:this.picCode,
                    shortMsg:this.msgCode
                },
                url:url
            }).then(res=>{
                if(res.errno == 0){
                    this.$router.replace({
                        name:'back-index',
                    });
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        //发送短信验证码
        sendMsg(){
            $http({
                method:'post',
                data:{
                    mobile:this.mobile,
                    verifyCode:this.picCode,
                    vCodeKey:'vcode'+md5(this.originImgsrc),
                    type:"3",//1登录 2注册 3其它
                },
                url:config.api.getSmsCode
            }).then(res=>{
                if(res.errno == 0){
                    Toast('验证码发送成功，5分钟内有效！');
                    // 开始倒计时
                    this.showCountdown=true;
                    this.$refs.countDown.start(); 
                }else{
                    Toast(res.errmsg);
                    this.picCode='';
                    this.getPicCode();
                }
            });
        },
        countdownFinish(){
            this.showCountdown=false;
            this.$refs.countDown.reset();
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-cell::after{
    border-bottom: none;
}
::v-deep .van-count-down{
    display: inline;
    color:#3088F5;
}

input::-webkit-input-placeholder{
    font-size: 15px;
}

.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    .price-section{
        background:#fff;
        .price-section-top{
            text-align: center;
            padding:20px 0;
            .price-text{
                font-size: 14px;
                color:#999;
            }
            .price-count{
                font-size: 22px;
                color:#333;
                margin-top: 10px;
            }
        }
        .price-section-bottom{
            @include flex-between();
            font-size: 14px;
            color:#999;
            padding:15px 30px;
            border-top: 1px solid #f5f5f5;
        }
    }
    .page-top{
        padding:10px;
        margin: 40px 0;
        &>div{
            color:#333;
            line-height: 28px;
            font-size: 15px;
            text-align: center;
            &>span{
                margin-left: 5px;
                font-size: 18px;
            }
            margin-bottom: 5px;
        }
    }
    .page-title{
        color:3333;
        font-size: 16px;
        line-height: 22px;
        &>span{
            font-size: 12px;
            color:#999;
            margin-left: 5px;
        }
        margin-bottom: 10px;
    }
    .page-content{
        padding:15px;
        .input-grp{
            margin-bottom: 15px;
            &>input{
                display: block;
                width:100%;
                height:44px;
                background:#fff;
                border:none;
                box-sizing: border-box;
                padding:0 20px;
                border-radius: 4px;
                font-size: 14px;
            }
            .notice{
                margin-top: 8px;
                font-size: 12px;
                color:#e43d3d;
            }
        }
        .btn-confirm{
            height: 44px;
            line-height: 44px;
            border-radius: 4px;
            text-align: center;
            font-size: 16px;
            margin-top: 70px;
            color:#fff;
            background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
            &.disabled{
                color:#999;
                background: #DCDCDC;
            }
        }
    }
    .step-2{
        .pic-code-box{
            @include flex-between();
            margin-bottom: 15px;
            &>input{
                width:250px;
                line-height:44px;
                box-sizing: border-box;
                padding:0 20px;
                font-size: 15px;
                background:#fff;
                border-radius: 4px;
                border:none;
            }
            .code-pic{
                width:78px;
                height:44px;
                border-radius: 4px;
            }
        }
        .msg-code-box{
            background:#fff;
            border-radius: 4px;
            @include flex-between();
            padding-right: 15px;
            &>input{
                width:200px;
                line-height:44px;
                box-sizing: border-box;
                padding:0 20px;
                font-size: 15px;
                background:#fff;
                border-radius: 4px;
                border:none;
            }
            .btn-getcode{
                font-size: 15px;
                color:#3088F5;
                line-height: 22px;
            }
        }
    }
    .page-bottom{
        position: fixed;
        width:100vw;
        text-align: center;
        bottom:15px;
        left:0;
        font-size: 14px;
        line-height: 20px;
        &>a{
            color:#3088F5;
        }
    }
}
</style>